import { ZfAccordion, ZfAccordionItem, ZfDialog, ZfDialogContent, ZfDialogFooter, ZfIcon, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface PartnerErrorScreenProps {
    businessRelationshipUuid?: string;
    showWhatYouCanTrySection: boolean;
    headingTextKey: string;
    warningTextKey: string;
}

export const PartnerErrorScreen: FunctionComponent<PartnerErrorScreenProps> = ({
    businessRelationshipUuid,
    showWhatYouCanTrySection,
    headingTextKey,
    warningTextKey,
}) => {
    const { t } = useTranslation();

    const [showWarning, setShowWarning] = useState(true);

    const onDialogClose = () => {
        setShowWarning(false);
    };

    return showWarning ? (
        <ZfDialog show={true} showCloseButton={true} size="s">
            <ZfDialogContent>
                <div className="partner-error-content ">
                    <div>
                        <ZfIcon name={'warning'} size={'extra-large'} className={'partner-error-content__icon'} />
                    </div>
                    <div className="partner-error-content__error-title">
                        <p>{t(headingTextKey)}</p>
                    </div>
                    <div className="partner-error-content__error-text">{t(warningTextKey)}</div>
                    {showWhatYouCanTrySection && (
                        <div className="partner-error-content__error-list">
                            <ZfAccordion type="multiple">
                                <ZfAccordionItem size="medium" titleText={t('whatYouCanTry')!} showUnderline={true} state={'active'}>
                                    <div className="body regular medium">
                                        <div className="row">{t('supportMessage')}</div>
                                    </div>
                                </ZfAccordionItem>
                                <ZfAccordionItem size="medium" titleText={'technicalDetails'} showUnderline={true}>
                                    {t('technicalDetailsExplanation')} {businessRelationshipUuid}
                                </ZfAccordionItem>
                            </ZfAccordion>
                        </div>
                    )}
                </div>
            </ZfDialogContent>
            <ZfDialogFooter>
                <ZfTextButton slot="primary" size="medium" onClick={onDialogClose}>
                    {t('modalCloseButton')}
                </ZfTextButton>
            </ZfDialogFooter>
        </ZfDialog>
    ) : null;
};
